import { loginStatus, SET_LOGIN_ATTEMPT, CLEAR_LOGIN_STATUS } from "../actions/loginActions"

const initialState = {
    loginStatus: loginStatus.none
}

export default function loginReducer( state = initialState, action ) {
    switch ( action.type ) {
        case CLEAR_LOGIN_STATUS:
            return {
                ...state,
                ...initialState
            }
        case SET_LOGIN_ATTEMPT:
            return {
                ...state,
                loginStatus: action.status
            }
        default: return state;
    }
}